// Utility to reset specific localStorage keys
function resetStorage(keysWithDefaults = {}) {
  // Iterate over the object entries
  Object.entries(keysWithDefaults).forEach(([key, defaultValue]) => {
    // Remove the key
    localStorage.removeItem(key);

    // Reinitialize with default value (if provided)
    if (defaultValue !== undefined) {
      localStorage.setItem(key, JSON.stringify(defaultValue));
    }
  });

  //console.log("✅ Selected storage keys reset:", Object.keys(keysWithDefaults));
}

export default resetStorage;